import axios from "axios";
import Cookies from 'js-cookie'
import { BASE_URL } from './../constant';

var CryptoJS = require("crypto-js");

function getToken() {
    let decryptedData;

    if (Cookies.get('S_UID') !== undefined) {
        var secretKey = 'Key-MOTION-ID@2023';
        var bytes = CryptoJS.AES.decrypt(Cookies.get('S_UID'), secretKey);
        decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } else {
        decryptedData = {};
    }

    return decryptedData;
}

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    const Data = getToken();
    config.headers.Authorization =  "Bearer " + Data.token;
     
    return config;
});

axios.defaults.baseURL = `${BASE_URL}/api`;
// axios.defaults.headers.common["Authorization"] = "Bearer " + decryptedData.token;
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.headers["Access-Control-Allow-Methods"] = "POST, GET, PUT";
axios.defaults.headers["Access-Control-Allow-Headers"] = "Content-Type, X-Auth-Token, Origin, Authorization";
axios.defaults.withCredentials = true;

// Ngrok Skip CORS
// axios.defaults.headers["ngrok-skip-browser-warning"] = "any";

axios.interceptors.response.use(function (res) {
    return res;
}, function (err) {
    if (err.response.status === 401) {
        Cookies.remove('S_UID', { path: '/', sameSite: 'lax', httpOnly: false });
        window.location.href = '/';
    } else {
        return Promise.reject(err);
    }
});

// const santumCors = () => {
//     return axios.get('/sanctum/csrf-cookie');
// }

const Signin = (data) => {
    return axios.post("/login", data);
}

const Logout = () => {
    return axios.post("/logout");
}
  
const Register = (data) => {
    return axios.post("/register", data);
}
  
const ForgotPassword = (data) => {
    return axios.post("/forgot-password", data);
}

const GetUser = () => {
    return axios.get("/user")
}

const UpdateProfile = (data) => {
    return axios.post("/updateProfile", data);
}

const ChangePassword = (data) => {
    return axios.post("/changePassword", data);
}

const SendVerification = () => {
    return axios.post("/SendVerification");
}

const VerifUser = (data) => {
    return axios.post("/verifUser", data);
}

const GetCompany = () => {
    return axios.get("/company")
}

const UpdateCompany = (data) => {
    return axios.post("/updateCompany", data);
}

const GetWishlist = () => {
    return axios.get("/wishlist")
}

const DeleteWishlist = (data) => {
    return axios.post("/deleteWishlist", data)
}

const AddWishlist = (data) => {
    return axios.post("/addWishlist", data)
}

const GetOrderHistory = () => {
    return axios.get("/getUserHistory")
}

const DownloadHistory = (data) => {
    return axios.post("/downloadHistory", data, {
        responseType: "blob"
    })
}

const GetBestSeller = () => {
    return axios.get('/products/bestSeller')
}

const GetRecommendProducts = () => {
    return axios.get('/products/recommend')
}

const DetailProduct = (sku) => {
    return axios.get(`/products/detail/${sku}`)
}

const AddSubscriber = (data) => {
    return axios.post("/addSubscriber", data)
}

const GetMainCategories = () => {
    return axios.get("/getMainCategories")
}

const GetCategoryDetails = (slug, brand, page, pageSize, sort) => {
    const query = `?brand=${brand}&page=${page}&pageSize=${pageSize}&sorted=${sort}`

    return axios.get(`/category/details/${slug}` + query)
}

const GetAbout = () => {
    return axios.get('/about-us')
}

const GetPeople = () => {
    return axios.get('/our-people')
}

const GetCareers = () => {
    return axios.get('/careers')
}

const GetNews = () => {
    return axios.get('/news')
}

const GetNewsDetail = (slug) => {
    return axios.get(`/news/${slug}`)
}

const GetResources = () => {
    return axios.get('/getResources')
}

const GetServices = () => {
    return axios.get('/getServices')
}

const SubmitQuote = (data) => {
    const headers = {
        'Content-Type': 'multipart/form-data',
    };
    
    return axios.post("/quote", data, {
        headers: headers,
    })
}

const SubmitFeedback = (data) => {
    return axios.post("/feedback", data)
}

const SubmitMessage = (data) => {
    return axios.post("/message", data)
}

const Search = (data) => {
    return axios.get(`/search?q=${data}`)
}

const getResultSearch = (params, page, pageSize, sort) => {
    const query = `?q=${params}&page=${page}&pageSize=${pageSize}&sorted=${sort}`

    return axios.get(`/searchResult` + query)
}

const CountCart = () => {
    return axios.get('/countCart')
}

const GetCart = () => {
    return axios.get('/getCart')
}

const AddCart = (data) => {
    return axios.post('/addCart', data)
}

const UpdateCart = (data) => {
    return axios.post('/updateCart', data)
}

const deleteItemsCart = (data) => {
    return axios.post('/deleteItemsCart', data)
}

const DeleteCart = () => {
    return axios.post('/deleteCart')
}

const CheckoutCart = (data) => {
    return axios.post('/checkoutCart', data)
}

const GetAllBrands = () => {
    return axios.get('/brands/all')
}

const getBrandProducts = (slug, cat, page, pageSize, sort) => {
    const query = `?cat=${cat}&page=${page}&pageSize=${pageSize}&sorted=${sort}`
    
    return axios.get(`/brands/details/${slug}` + query)
}

// LocalStorage Cart System
const GetCartProductLS = (data) => {
    return axios.post('/getCartLS', data)
}

const CheckoutLS = (data) => {
    return axios.post('/checkoutLS', data)
}

const Services = {
    // santumCors,
    Signin,
    Logout,
    Register,
    ForgotPassword,
    GetUser,
    UpdateProfile,
    ChangePassword,
    SendVerification,
    VerifUser,
    GetCompany,
    UpdateCompany,
    GetWishlist,
    DeleteWishlist,
    AddWishlist,
    GetOrderHistory,
    DownloadHistory,
    GetBestSeller,
    GetRecommendProducts,
    DetailProduct,
    AddSubscriber,
    GetMainCategories,
    GetCategoryDetails,
    GetAbout,
    GetPeople,
    GetCareers,
    GetNews,
    GetNewsDetail,
    GetResources,
    GetServices,
    SubmitQuote,
    SubmitFeedback,
    SubmitMessage,
    Search,
    getResultSearch,
    CountCart,
    GetCart,
    AddCart,
    UpdateCart,
    deleteItemsCart,
    DeleteCart,
    CheckoutCart,
    GetAllBrands,
    getBrandProducts,
    GetCartProductLS,
    CheckoutLS,
}

export default Services;